import { Eye, EyeSlash } from 'iconsax-react';
import { type ComponentProps, forwardRef, useState } from 'react';
import cn from '@/utils/merge-class-names';

type PasswordFieldProps = ComponentProps<'input'>;

const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(({ className, ...restProps }, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className={cn('input join input-bordered w-full focus:input-primary', className)}>
      <input
        type={showPassword ? 'text' : 'password'}
        className='join-item w-full flex-1'
        {...restProps}
        ref={ref}
      />
      <button
        type='button'
        className='join-item'
        onClick={(e) => {
          e.preventDefault();
          setShowPassword(!showPassword);
        }}>
        {showPassword ? <Eye /> : <EyeSlash />}
      </button>
    </div>
  );
});

PasswordField.displayName = 'PasswordField';

export default PasswordField;
